import React, { useState } from "react";
import { useSelector } from "react-redux";
import { getCustomizeCanvas } from "../../redux/creators/customizeCreators";
import "../../../../css/customize.css";
import Alignment from "../../../customizer/Alignment";
import Font from "../../../customizer/Font";
import LineHeight from "../../../customizer/LineHeight";
import Size from "../../../customizer/Size";
import Style from "../../../customizer/Style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAlignCenter,
  faBold,
  faFont,
  faTextHeight,
  faUpRightAndDownLeftFromCenter,
} from "@fortawesome/free-solid-svg-icons";

/**
 * Handles the customizer's extra text toolbar on mobile.
 *
 * @returns {Object}
 */
export default function MobileTextTools() {
  const [visibleTool, setVisibleTool] = useState("");
  const { canvas } = useSelector((state) => ({
    canvas: getCustomizeCanvas(state),
  }));

  return (
    <>
      <div id="textToolsMobile">
        {visibleTool == "font" && <Font view="mobile" canvas={canvas} />}
        {visibleTool == "size" && <Size view="mobile" canvas={canvas} />}
        {visibleTool == "align" && <Alignment canvas={canvas} />}
        {visibleTool == "style" && <Style canvas={canvas} />}
        {visibleTool == "height" && (
          <LineHeight view="mobile" canvas={canvas} />
        )}
        {visibleTool == "scale" && <Scale view="mobile" canvas={canvas} />}
      </div>

      <button className="fabric-button" onClick={() => setVisibleTool("font")}>
        <FontAwesomeIcon icon={faFont} />
        <div className="toolbar-text">Font</div>
      </button>

      <button className="fabric-button" onClick={() => setVisibleTool("size")}>
        <FontAwesomeIcon icon={faUpRightAndDownLeftFromCenter} />
        <div className="toolbar-text">Size</div>
      </button>

      <button className="fabric-button" onClick={() => setVisibleTool("align")}>
        <FontAwesomeIcon icon={faAlignCenter} />
        <div className="toolbar-text">Align</div>
      </button>

      <button className="fabric-button" onClick={() => setVisibleTool("style")}>
        <FontAwesomeIcon icon={faBold} />
        <div className="toolbar-text">Style</div>
      </button>

      <button
        className="fabric-button"
        onClick={() => setVisibleTool("height")}
      >
        <FontAwesomeIcon icon={faTextHeight} />
        <div className="toolbar-text">Line Height</div>
      </button>
    </>
  );
}
